import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TitleBar from "../titleBar";
import Box from "../box";
import { getLocalStateValue } from "../../../utils/helpers";
import InfoModal from "../infoModal";

// image imports
import Gas from "../../../assets/heating_types/gas.png";
import Electricity from "../../../assets/heating_types/electricity.png";
import Pipe from "../../../assets/heating_types/pipe.png";
import Bonfire from "../../../assets/heating_types/bonfire.png";

type VerwarmingProps = {
    globals?: {
        colors: {
            default: ""
        }
    },
    pageData?: {
        back_text: string,
        title: string,
        description: string,
        next_url: string,
        prev_url: string
    }
    updateAnswer?: (title: string, answer: string, url?: string) => void,
    storeAnswer?: (data: any, key: string) => void,
    modalInformation?: any
}

const Verwarming = ({ globals, pageData, updateAnswer = () => {}, storeAnswer = () => {}, modalInformation }: VerwarmingProps) => {
    const [ hoverState, setHoverState ] = useState(0);
    const [ activeBox, setActiveBox ] = useState("");
    const [ modalState, setModalState ] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const localState = getLocalStateValue("6");
        if (localState) {
            setActiveBox(localState.answerNo);
        }
    }, [])

    const goBack = () => {
        navigate(pageData?.prev_url || "")
    }

    function removeSpaces(string: string) {
        return string.replace(/\s/g, '');
    }

    const getImage = (answerIndex?: string) => {
        switch(answerIndex) {
            case "0":
                return Gas;
            case "1":
                return Electricity;
            case "2":
                return Pipe;
            case "3":
                return Bonfire;
            default:
                return Gas;
        }
    }
    
    const onClick = (answer?: string, answerIndex?: string) => {
        const question = "verwarming";
        let nextUrl = answer?.toLowerCase();
        nextUrl = removeSpaces(nextUrl || "");
        updateAnswer(question || "", answer || "", `/vraag/${nextUrl}`);
        storeAnswer({"answerNo": answerIndex, "verwarming": nextUrl, image: getImage(answerIndex)}, "6")
    }

    const openInformationModal = () => {
        setModalState(true);
    }

    return(
        <div className = "w-full flex justify-center box-border">
            <div className = "container mx-auto flex-col justify-center box-border px-[16px] md:px-16 lg:px-32">
                <TitleBar back_text = {pageData?.back_text} infoColor = {globals?.colors?.default} title = {pageData?.title} description = {pageData?.description} goBack = {goBack} openInfoModal={openInformationModal} />
                <div className = "w-full flex flex-col mt-[10px] mb-[100px]">
                    <div className = "w-full flex flex-col md:flex-row border-b-[1px] border-b-[#F0F5F5]">
                        <Box flex = {1} hasRightBorder text = "Gas" hoverValue = {1} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {Gas} answerIndex = "0" isActive = {activeBox === "0"} />
                        <Box flex = {1} hasRightBorder text = "Elektriciteit" hoverValue = {2} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {Electricity} answerIndex = "1" isActive = {activeBox === "1"} />
                        <Box flex = {1} hasRightBorder text = "Stookolie" hoverValue = {3} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {Pipe} answerIndex = "2" isActive = {activeBox === "2"} />
                        <Box flex = {1} hasRightBorder text = "Een andere bron" hoverValue = {4} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {Bonfire} answerIndex = "3" isActive = {activeBox === "3"} />
                    </div>
                </div>
            </div>
            <InfoModal modalInformation = {modalInformation} isModalOpen = {modalState} closeModal = {() => setModalState(false)} />
        </div>
    )
}

export default Verwarming;